<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
       <vs-list>
        <vs-list-header title="그림카드 선택후 음가에 유의해 다음 단어를 말해 보세요." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="vx-row">
        <div class="vx-col sm:w-1/3 md:w-1/3 w-full mb-4" :key="index" v-for="(item, index) in contentList">
            <vx-card class="phonics-sm-card flex items-center justify-center" @click="onImageClick(index)">
              <flip-card  :prevent-event="preventEvent" :ref="'flipCard_' + index">
                <template slot="back" class="phonics-sm-card">
                  <div class="mb-4">
                    <h2 class="text-primary sentence text-center">{{ item.sentence }}</h2>
                    <br>
                    <h2 class="text-primary sentence text-center"> {{ item.translation}} </h2>
                  </div>
                </template>
                <template slot="front">
                  <div slot="no-body">
                    <img :src="item.image" class="image-card-height">
                  </div>
                </template>
              </flip-card>
            </vx-card>
        </div>
      </div>

      <div v-show="recordingPrepared">
        <div class="text-center mt-3">
          <vue-record-audio  :mode="recordMode.audio" @result="onResult" />
        </div>
        
      </div>
      <vs-alert v-show="recordingPrepared" class="mt-3 text-center" >
        위 버튼을 누른 상태에서 녹음을 진행합니다. 녹음이 끝나면 버튼을 놓으세요.
      </vs-alert>
      <div v-show="recordingFinished" class="text-center mt-3">
        <audio ref="userAudioPlayer" :src="recording" controls v-on:ended="userAudioFinish"  />
      </div>

    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      recordMode: {
        audio: 'hold',
        video: 'press'
      },
      recording: '',
      recordingPrepared: false,
      recordingFinished: false,
      preventEvent: false,
      page: 0,
      totalContentList: []
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    },
    userAudioPlayer () {
      return this.$refs.userAudioPlayer
    }
  },
  methods: {
    onResult (data) {
      this.recording = window.URL.createObjectURL(data)
      this.recordingFinished = true
      this.recordingPrepared = false

      setTimeout(function () {
        this.userAudioPlayer.play()
      }.bind(this), 1000)
      
    },
    onReload () {

      for (let i = 0; i < this.totalContentList.length; i++) {
        const arrTemp = this.totalContentList[i]
        arrTemp.forEach(function (element) {
          element.finished = false
        })
      }

      this.userAudioPlayer.pause()
      //this.$refs.flipCard.resetFlip()
      this.page = 0
      this.contentIndex = 0
      this.recordingPrepared = false
      this.recordingFinished = false
      this.contentList = this.totalContentList[0]
      this.startAlert()
    },
    onImageClick (index) {

      this.preventEvent = true
      this.contentIndex = index

      setTimeout(function () {
        this.recordingPrepared = true
      }.bind(this), 1500)
    },
    onStart () {
      
    },
    audioFinish () {
      
    },
    resetFlip () {
      this.$refs['flipCard_0'][0].resetFlip()
      this.$refs['flipCard_1'][0].resetFlip()
      this.$refs['flipCard_2'][0].resetFlip()
      this.$refs['flipCard_3'][0].resetFlip()
      this.$refs['flipCard_4'][0].resetFlip()
      this.$refs['flipCard_5'][0].resetFlip()
    },
    userAudioFinish () {

      this.contentList[this.contentIndex].finished = true
      this.recordingPrepared = false
      this.recordingFinished = false
      this.preventEvent = false


      let completed = true
      for (let i = 0; i < this.contentList.length; i++) {
        if (this.contentList[i].finished === false) {
          completed = false
          break
        }
      }

      if (completed) {
        if (this.page === (this.totalContentList.length - 1)) {
          this.onComplete()
        } else {
          this.page++
          this.contentList = this.totalContentList[this.page]
          this.resetFlip()
          //this.isStudying = false
        }
      } else {
        //this.isStudying = false
      }

      // this.preventEvent = false
      // setTimeout(function () {
      //   this.$refs.flipCard.doFlip()

      //   // 카드 복원
      //   setTimeout(function () {
      //     this.preventEvent = true
      //     this.$refs.flipCard.resetFlip()

      //     // 다음 문제 진행
      //     setTimeout(function () {
      //       if (this.contentIndex >= this.contentsLen - 1) {
      //         this.onComplete() 
      //       } else {
      //         this.contentIndex++
      //         this.audioFinished = false
      //         this.recordingFinished = false
      //         this.onStart()
      //       }
      //     }.bind(this), 1000)

      //   }.bind(this), 2000)

      // }.bind(this), 1000)
    },
    startAlert () {
      this.startStudyDlg('그림카드 선택후 음가에 유의해 다음 단어를 말해 보세요.')
    },
    acceptAlert () {
      //this.onStart()
    },
    chunk (arr, size) {
      let i, j, temparray = [], chunk = size
      for (i = 0, j = arr.length; i < j; i += chunk) {
        temparray.push(arr.slice(i, i + chunk))
      }
      return temparray
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    const arrContent = new Array()
    for (let i = 1; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1),
        image: this.$buildImagePath(this.sourceContent.contentCode, i),
        finished: false
      } 
      arrContent.push(content)
    }
    
    // 컨텐츠를 6개씩 나눈다.
    this.totalContentList = this.chunk(arrContent, 6)
    this.contentList = this.totalContentList[0]
    this.contentsLen = this.contentList.length
    this.startAlert()
  },
  mounted () {
  }
}

</script>

<style scoped>
.ww-jumbotron-content-sentence {
    border:1px solid #7367F0;
}
.ww-jumbotron-content-translation {
    border:1px solid #28C76F;
}
.tc-ww-input {
    height: 50px;
    width: 200px;
    font-size: 30px;
    text-align: center;
    letter-spacing:10px;
} 
</style>